import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Inscription self-service désactivée (IAM organisation). Explique le flux :
 * identifiant + mot de passe initial communiqué par l’org, changement obligatoire à la 1re connexion.
 */
const Register = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto flex min-h-screen max-w-2xl flex-col px-4 py-12 sm:px-6">
        <Link
          to="/"
          className="mb-6 text-sm font-medium text-entrea-royal hover:text-entrea-ink"
        >
          ← Accueil
        </Link>

        <div className="rounded-xl border border-slate-200 bg-entrea-surface px-6 py-8 shadow-sm sm:px-10 sm:py-10">
          <h1 className="text-2xl font-bold text-slate-900 sm:text-3xl">Rejoindre Entrea</h1>
          <p className="mt-3 text-slate-600 leading-relaxed">
            L&apos;inscription en ligne directe n&apos;est pas activée : les comptes sont créés par{' '}
            <strong>votre organisation</strong> (administrateur Entrea ou outil de gestion des membres).
          </p>

          <div className="mt-8 space-y-4 rounded-lg border border-entrea-sky/30 bg-white/90 p-5 text-sm text-slate-700 leading-relaxed">
            <p className="font-semibold text-slate-900">Comment ça marche pour un membre standard ?</p>
            <ol className="list-decimal space-y-3 pl-5">
              <li>
                Votre organisation vous communique un <strong>identifiant</strong> (souvent votre numéro de téléphone
                ou e-mail) et un <strong>mot de passe initial</strong> — en général le <em>même pour tous les nouveaux
                comptes</em> de l&apos;association, défini côté plateforme.
              </li>
              <li>
                À la <strong>première connexion</strong>, vous devez <strong>choisir un mot de passe personnel</strong>{' '}
                : vous ne pourrez pas continuer sans le changer.
              </li>
            </ol>
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Link
              to="/login"
              className="inline-flex justify-center rounded-lg bg-entrea-royal px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-entrea-ink"
            >
              Se connecter
            </Link>
            <Link
              to="/register-organization"
              className="inline-flex justify-center rounded-lg border border-entrea-sky/40 bg-white px-6 py-3 text-sm font-semibold text-entrea-royal hover:bg-entrea-panel"
            >
              Enregistrer une organisation
            </Link>
            <Link
              to="/forgot-password"
              className="inline-flex justify-center rounded-lg px-6 py-3 text-sm font-medium text-slate-600 underline hover:text-slate-900"
            >
              Problème d&apos;accès ?
            </Link>
          </div>

          <p className="mt-8 text-xs text-slate-500">
            Accès équipes / administration :{' '}
            <Link to="/portal/login" className="font-medium text-entrea-royal hover:text-entrea-ink">
              Connexion administrateur
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
